import { render, staticRenderFns } from "./CustomerSuccessLogsTab.vue?vue&type=template&id=669bfad5&"
import script from "./CustomerSuccessLogsTab.vue?vue&type=script&lang=ts&"
export * from "./CustomerSuccessLogsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports